// auth.guard.ts
import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthGuard2 implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (!sessionStorage.getItem("username")) {
      // User is logged in, redirect to the dashboard
      // console.log('User Logout');
      this.router.navigate(["/login"]);
      return false;
    }
    return true;
  }
}
